<template>
  <div class="flex mt-3" />
  <TwcHeading v-if="option.label" tag="h6" class="mb-1 w-full text-sm font-semibold">
    {{ option.label }}
  </TwcHeading>
  <div class="grid grid-cols-2 gap-4">
    <SelectionButton
      v-for="(value, index) in sortedValues"
      :key="index"
      :value="value.id"
      :selected="isSelected(value.id)"
      :data-testid="`single-select-${value.id}`"
      :title="value.name"
      :description="value.description"
      @click="onClicked(value)"
    >
    </SelectionButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { TwcHeading } from 'transit-web-components'
import SelectionButton from '@/components/inputs/SelectionButton.vue'

const emit = defineEmits(['click'])

const props = defineProps({
  option: {
    type: Object as () => ProductOption,
    required: true
  },
  selectedOptionsIds: {
    type: Array<string>,
    default: []
  }
})

const sortedValues = computed(() =>
  [...props.option.values].sort((val1, val2) => val1.priority - val2.priority)
)

function onClicked(value: ProductOptionValue) {
  emit('click', props.option, value.id)
}

function isSelected(id: string) {
  return props.selectedOptionsIds.includes(id)
}
</script>

<style scoped></style>
